import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Content, { HTMLContent } from '../components/Content';
import { ContactForm } from '../views/contact-form';
import { Contacts } from '../components/contacts';

export const SimpleArticleTemplate = ({ title, content, contentComponent }) => {
  const PageContent = contentComponent || Content;

  return (
    <section className="section">
      <div className="container">
        <h1 className="title is-1 has-text-centered">{title}</h1>
        <PageContent className="content" content={content} />
        <hr />
        <div className="columns">
          <div className="column">
            <Contacts />
          </div>
          <div className="column">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

const SimpleArticle = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <Layout title={post.frontmatter.title}>
      <SimpleArticleTemplate
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        content={post.html}
      />
    </Layout>
  );
};

export default SimpleArticle;

export const simpleArticleQuery = graphql`
  query SimpleArticle($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`;
